<template>
	<div id="ecommerce">
		<div v-if="isSelectedBot">
			<div class="container">
				<ul class="nav nav-tabs" style="padding-top:15px;">
					<li class="nav-item" :class="{'active' : currentView == 'products'}">
						<a class="nav-link" href="javascript:void(0);" @click="currentView = 'products'"><i class="fas fa-tshirt"></i> Products</a>
					</li>
					<li class="nav-item" :class="{'active' : currentView == 'ecommerce-order-summary'}" >
						<a class="nav-link" href="javascript:void(0);" @click="currentView = 'ecommerce-order-summary'"><i class="fas fa-box"></i> Order Summary</a>
					</li>
				</ul>
				<div class="tab-container">
					<br>
					<component :is="currentView"></component>
				</div>
			</div>
		</div>
		<div v-else>
			<template-empty></template-empty>
		</div>
	</div>
</template>

<script>
import Products from './Products'
import ecommerceOrderSummary from './ecommerce-order-summary'
import templateEmpty from '@/components/view/template/template-empty'



export default{
	data: function(){
		return {
			currentView: 'products'
		}
	},
	components:{
		'template-empty' : templateEmpty,
		'products' : Products,
		'ecommerce-order-summary' : ecommerceOrderSummary,
	},
	created(){
		let vm = this
		if (vm.$route.query.tab) {
			switch(vm.$route.query.tab) {
				case 'products':
				case 'ecommerce-category':
				case 'ecommerce-order-summary':
					vm.currentView = vm.$route.query.tab;
					break;
				default:
					vm.currentView = 'products';
					break;
			}

		} else {
			vm.currentView = 'products';
		}
	},
	computed:{
		isSelectedBot: function(){
			return this.$store.state.isSelectedBot
		}
	},
	methods: {
		updateRoute: function() {
			this.$router.push({
				name: 'template',
				path: '/template', 
				query: { 
					tab: this.currentView
				}
			})
			this.routeValue = JSON.stringify(this.$route.query)
		}
	},
	watch: {
		currentView: function(){
			this.updateRoute()
		}
	}
}
</script>


// WEBPACK FOOTER //
// src/components/view/template/ecommerce/ecommerce.vue